// 9fbef606107a605d69c0edbcd8029e5d
import React from 'react';
import { getDynamicLabelValues } from '../../../../../../../utils/labels/labelUtilty';
import {
  CategoryHeader,
  CategoryContainer,
  CategoryButton,
} from '../styles/CategorySelector.style';

const CategorySelector = ({ categoryData, activeCategory, onSelectCategory }) => (
  <div className="dynamic-size-chart-category-section">
    <CategoryHeader className="category-title-section" tabIndex="0">
      {getDynamicLabelValues('dynamic.global_d.lbl_size_chart_category_title')}
    </CategoryHeader>
    <CategoryContainer className="category-buttons-section">
      {categoryData.category.map((category) => (
        <CategoryButton
          key={`${category.name}_category`}
          id={`${category.name}_category`}
          className={`${
            activeCategory === category.name
              ? `active_${category.name}_category`
              : `inactive_${category.name}_category`
          }`}
          isActive={activeCategory === category.name}
          onClick={() => onSelectCategory(category.name)}
        >
          {category.name}
        </CategoryButton>
      ))}
    </CategoryContainer>
  </div>
);

export default CategorySelector;
